'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _jsx = require('@babel/runtime/helpers/jsx');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
require('react');
require('prop-types');
var htmlToText = require('html-to-text');
var marked = require('marked');
var serialize = require('serialize-javascript');
const TYPE = '@type';
const ML_LOGO = 'https://http2.mlstatic.com/frontend-assets/homes-palpatine/logo_homecom_v2.png';
const SITE_MLB = 'MLB';
const MLB_PUBLISHER = 'MercadoLivre';
const DEFAULT_PUBLISHER = 'MercadoLibre';
const BlogSchema = _ref => {
  let {
    headline,
    description,
    image,
    author,
    editor,
    publisherLogo,
    datePublished,
    dateModified,
    url,
    articleSection,
    articleBodyHtml,
    articleBodyMarkdown,
    siteId
  } = _ref;
  const convertToPlainText = (html, markdown) => {
    const options = {
      selectors: [{
        selector: 'a',
        options: {
          ignoreHref: true
        }
      }]
    };
    if (html) {
      return htmlToText.htmlToText(html, options);
    }
    if (markdown) {
      return htmlToText.htmlToText(marked.marked.parse(markdown), options).toLowerCase();
    }
    return '';
  };
  const calculateWordCount = text => {
    return text.split(/\s+/).filter(word => word.length > 0).length;
  };
  const articleBody = convertToPlainText(articleBodyHtml, articleBodyMarkdown);
  const wordCount = calculateWordCount(articleBody);
  const schemaData = {
    '@context': 'https://schema.org',
    [TYPE]: 'Article',
    headline,
    description,
    image,
    publisher: {
      [TYPE]: 'Organization',
      name: siteId === SITE_MLB ? MLB_PUBLISHER : DEFAULT_PUBLISHER,
      logo: {
        [TYPE]: 'ImageObject',
        url: publisherLogo || ML_LOGO
      }
    },
    datePublished,
    dateModified,
    mainEntityOfPage: {
      [TYPE]: 'WebPage',
      '@id': url
    },
    articleSection,
    articleBody,
    wordCount
  };
  const addPersonToSchema = (role, person) => {
    if (person) {
      schemaData[role] = _objectSpread({
        [TYPE]: 'Person'
      }, person);
    }
  };
  addPersonToSchema('author', author);
  addPersonToSchema('editor', editor);
  return /*#__PURE__*/_jsx("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: serialize(schemaData, {
        isJSON: true
      })
    }
  });
};
BlogSchema.defaultProps = {
  author: undefined,
  editor: undefined,
  publisherLogo: '',
  articleBodyHtml: '',
  articleBodyMarkdown: ''
};
exports.default = BlogSchema;
